"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var framer_motion_1 = require("framer-motion");
function Conteudo(_a) {
  var conteudo = _a.conteudo,
    props = __rest(_a, ["conteudo"]);
  var variantes = {
    aberto: {
      opacity: 1,
      height: "auto",
      maxHeight: 300,
      fontSize: "18px",
      "overflow-y": "hidden"
    },
    fechado: {
      opacity: 0,
      height: 0
    }
  };
  return react_1.default.createElement(framer_motion_1.motion.section, __assign({
    layout: true,
    transition: {
      duration: 0.6,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    initial: "fechado",
    animate: "aberto",
    exit: "fechado",
    variants: variantes
  }, props), conteudo);
}
exports.default = Conteudo;